import { Navigate, Outlet } from "react-router-dom";
const ProtectedRoute = ({ isAuthenticated, redirectPath = "/auth" }: { isAuthenticated: boolean; redirectPath?: string }) => {
    if (!isAuthenticated) {
        return <Navigate to={redirectPath} replace />;
    }
    return <Outlet />;
};
export default ProtectedRoute;
